import * as React from 'react';

import { FormStatus } from 'entities/common';
import {
  EditFormStoreContextProvider,
  UploadFormStoreProvider,
  VerificationFormStoreProvider,
} from 'stores/local';

import { EditFormPage } from './EditFormPage';
import { EditFormButtonNodes } from './EditFormPage/components';
import { FormFillingPage } from './FormFillingPage';
import { FileUploadButtonNodes } from './FormFillingPage/FormFillingButtonNodes';
import { VerificationFormPage } from './VerificationFormPage';
import { VerificationButtonNodes } from './VerificationFormPage/VerificationButtonNodes';

/**
 * Конфиг компонент шагов
 */
export const MAP_STATUS_TO_COMPONENTS: Record<
  string,
  {
    component: React.ReactNode;
    buttonNodes?: React.ReactNode;
    context: React.ComponentType<React.PropsWithChildren>;
  }
> = {
  [FormStatus.DRAFT]: {
    component: <EditFormPage />,
    context: EditFormStoreContextProvider,
    buttonNodes: <EditFormButtonNodes />,
  },
  [FormStatus.FILE_UPLOAD]: {
    component: <FormFillingPage />,
    context: UploadFormStoreProvider,
    buttonNodes: <FileUploadButtonNodes />,
  },
  [FormStatus.VALIDATION]: {
    context: VerificationFormStoreProvider,
    component: <VerificationFormPage />,
    buttonNodes: <VerificationButtonNodes />,
  },
  [FormStatus.PUBLISHED]: {
    context: VerificationFormStoreProvider,
    component: <VerificationFormPage />,
    buttonNodes: <VerificationButtonNodes />,
  },
  [FormStatus.FINISHED]: {
    context: VerificationFormStoreProvider,
    component: <VerificationFormPage />,
    buttonNodes: <VerificationButtonNodes />,
  },
};
